import React from "react";

const PreviewKPIGrid = ({ tab, cardTheme, chartTheme, tableTheme }) => {
  if (!tab) return null;

  if (!tab.kpis || tab.kpis.length === 0) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
        No KPIs added to this tab yet
      </div>
    );
  }

  return (
    <div className="preview-kpi-grid">
      {tab.kpis.map((kpi) => {
        // Display title from KPI JSON
        const kpiTitle = kpi.qTitle || kpi.title || kpi.variableName || "Unnamed KPI";
        
        const cardStyle = {
          background: cardTheme?.background || "#ffffff",
          padding: "16px",
          borderRadius: "8px",
          boxShadow: cardTheme?.shadow || "0 2px 8px rgba(0,0,0,0.08)",
          border: cardTheme?.borderColor !== "transparent" ? `1px solid ${cardTheme?.borderColor}` : "none",
          transition: "box-shadow 0.2s",
        };

        const titleStyle = {
          marginBottom: "12px",
          fontSize: "16px",
          fontWeight: "600",
          color: cardTheme?.titleColor || "#333333",
        };

        return (
          <div key={kpi.id} className="preview-kpi-card" style={cardStyle}>
            <h4 className="kpi-title" style={titleStyle}>
              {kpiTitle}
            </h4>

            {kpi.viewMode === "table" ? (
              // Table view - show actual data from JSON with theme
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ 
                      borderBottom: `2px solid ${tableTheme?.borderColor || "#e5e7eb"}`,
                      background: tableTheme?.headerBackground || "#f3f4f6",
                    }}>
                      <th style={{ 
                        padding: "10px", 
                        textAlign: "left",
                        color: tableTheme?.headerTextColor || "#111827",
                        fontWeight: "600",
                      }}>
                        Label
                      </th>
                      <th style={{ 
                        padding: "10px", 
                        textAlign: "right",
                        color: tableTheme?.headerTextColor || "#111827",
                        fontWeight: "600",
                      }}>
                        Count
                      </th>
                      <th style={{ 
                        padding: "10px", 
                        textAlign: "right",
                        color: tableTheme?.headerTextColor || "#111827",
                        fontWeight: "600",
                      }}>
                        %
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {kpi.data && kpi.data.length > 0 ? (
                      kpi.data.map((row, i) => (
                        <tr 
                          key={i} 
                          style={{ 
                            borderBottom: `1px solid ${tableTheme?.borderColor || "#e5e7eb"}`,
                            background: tableTheme?.rowBackground || "#ffffff",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = tableTheme?.rowHoverBackground || "#f9fafb";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = tableTheme?.rowBackground || "#ffffff";
                          }}
                        >
                          <td style={{ 
                            padding: "10px",
                            color: tableTheme?.textColor || "#374151",
                          }}>
                            {row.name || row.label || "-"}
                          </td>
                          <td style={{ 
                            padding: "10px", 
                            textAlign: "right",
                            color: tableTheme?.textColor || "#374151",
                          }}>
                            {row.value !== undefined ? row.value : row.count || "-"}
                          </td>
                          <td style={{ 
                            padding: "10px", 
                            textAlign: "right",
                            color: tableTheme?.textColor || "#374151",
                          }}>
                            {row.percent !== undefined ? `${row.percent}%` : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" style={{ 
                          padding: "12px", 
                          textAlign: "center", 
                          color: "#999" 
                        }}>
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {kpi.data && kpi.data[0]?.base && (
                  <div style={{ 
                    marginTop: "8px", 
                    fontSize: "12px", 
                    color: cardTheme?.textColor || "#666" 
                  }}>
                    Base: {kpi.data[0].base}
                  </div>
                )}
              </div>
            ) : (
              // Chart view - show placeholder with chart type and theme colors
              <div 
                className="chart-placeholder"
                style={{
                  height: "220px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  background: chartTheme?.background || "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)",
                  borderRadius: "6px",
                  fontSize: "18px",
                  color: chartTheme?.textColor || "#4f46e5",
                }}
              >
                📊 {kpi.chartType || "Chart"}
                {kpi.data && kpi.data.length > 0 && (
                  <div style={{ 
                    fontSize: "12px", 
                    marginTop: "8px", 
                    color: chartTheme?.textColor || "#666" 
                  }}>
                    {kpi.data.length} data points
                  </div>
                )}
                {/* Show color palette preview */}
                {chartTheme?.colors && (
                  <div style={{ 
                    display: "flex", 
                    gap: "4px", 
                    marginTop: "12px" 
                  }}>
                    {chartTheme.colors.slice(0, 5).map((color, idx) => (
                      <div
                        key={idx}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "4px",
                          background: color,
                          border: "1px solid rgba(0,0,0,0.1)",
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PreviewKPIGrid;